import React, { CSSProperties, memo, useContext } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { LayoutSettings, MenuItem } from '@/types';
import BaseLayoutContext, { ILayoutContext } from '@/context/LegacyLayoutContext';
import classNames from 'classnames';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from '@/graphql/operations/user';
import styles from './SideMenu.module.pcss';

interface Props extends Partial<LayoutSettings> {
  mode?: string;
  style?: CSSProperties;
  className?: string;
  layout?: string;
  menuItems: MenuItem[];
  toggleSideBar: () => void;
}

const BaseMenu = memo<Props>((props) => {
  const location = useLocation();
  const currentUser = useReactiveVar(currentUserVar);
  const layoutContext = useContext<ILayoutContext>(BaseLayoutContext);

  const getMenuItemPath = (item: MenuItem) => {
    return (
      <Link to={item.path} replace={item.path === location.pathname}>
        <span>{item.title}</span>
      </Link>
    );
  };

  const getNavMenuItems = () => {
    return props.menuItems.map((item) => {
      if (
        (item.participant && !item.admin && currentUser.permissions?.isAdmin) ||
        (item.admin && !item.participant && !currentUser.permissions?.isAdmin)
      ) {
        return null;
      }
      return {
        key: item.path,
        label: getMenuItemPath(item),
        icon: item.icon,
        className: styles.menuItem,
      };
    });
  };

  return (
    <Menu
      className={classNames(styles.baseMenu, styles[layoutContext.layoutConfig?.title.name])}
      mode="inline"
      selectedKeys={[location.pathname]}
      items={getNavMenuItems()}
    />
  );
});

export default BaseMenu;
